const $window = $(window);
const breakPoint = 767;

let resizeFlag = false;
let windowWidth = $window.width();
let windowHeight = $window.height();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//SPヘッダーの開閉
import {spHeaderToggle} from "../include/module";
spHeaderToggle();

//Headerスクロール時
import {scrolledHeader} from "../include/module";
scrolledHeader();

//YouTubeのモーダル
const youtubeModal = () => {
  const $modal = $('.season-Movie_Modal');
  const $content = $('.season-Movie_Modal-Content');
  const $youtube = $('.js-Youtube');
  // open
  $youtube.on('click', function(){
    $(this).blur();
    const dataID = $(this).attr('data-youtube');
    //iframe append
    $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
    // fadeIn
    $modal.stop().fadeIn(400);
    return false;
  });
  //close
  $('.season-Movie_Modal-Overlay,.season-Movie_Modal-Close').on('click', function(){
    $modal.stop().fadeOut(400, function(){
      $content.children('iframe').remove();
    });
  });
};
youtubeModal();

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();


// WEBPACK FOOTER //
// ./src/assets/js/season/script.js